import { useState, useCallback, useRef } from 'react'
import { GalleryPhoto } from '../types'

export function useGalleryModal() {
  const [selectedPhoto, setSelectedPhoto] = useState<GalleryPhoto | null>(null)
  const [confirmDeletePhoto, setConfirmDeletePhoto] = useState<GalleryPhoto | null>(null)
  const fileInputRef = useRef<HTMLInputElement>(null)

  const openPreview = useCallback((photo: GalleryPhoto) => {
    setSelectedPhoto(photo)
  }, [])

  const closePreview = useCallback(() => {
    setSelectedPhoto(null)
  }, [])

  const openDeleteConfirm = useCallback((photo: GalleryPhoto) => {
    setConfirmDeletePhoto(photo)
  }, [])

  const closeDeleteConfirm = useCallback(() => {
    setConfirmDeletePhoto(null)
  }, [])

  const triggerFileInput = useCallback(() => {
    fileInputRef.current?.click()
  }, [])

  return {
    selectedPhoto,
    confirmDeletePhoto,
    fileInputRef,
    openPreview,
    closePreview,
    openDeleteConfirm,
    closeDeleteConfirm,
    triggerFileInput
  }
}
